import { Component, OnInit, Input } from '@angular/core';
import { BsModalService } from "ngx-bootstrap";
import { ApiService, VOC, WarehouseDebtRecordDTO } from "../../../../../../projects/accounting/src/public_api";

export interface DetailsViewerData {
  vendor: VOC;
  period: string;
}

@Component({
  selector: 'vendor-details-viewer',
  templateUrl: './details-viewer.component.html',
  styleUrls: ['./details-viewer.component.scss']
})
export class DetailsViewerComponent implements OnInit {

  @Input() data: DetailsViewerData;

  loading = false;

  records: Array<WarehouseDebtRecordDTO> = [];
  total: number = 0;

  constructor(
    private bsModal: BsModalService,
    private api: ApiService
  ) { }

  ngOnInit() {

    this.total = 0;

    this.loading = true;
    console.log(this.data);

    this.api.debtToVendor({ ID: this.data.vendor.id, Period: this.data.period }).subscribe(
      response => {

        this.records = response.succeed && response.data != null ? response.data : [];
        this.records.forEach(i => this.total += i.Amount);

        this.loading = false;
      },
    );
  }
}
